import type { TFunction } from 'i18next';

export type LayoutProblem =
  | { kind: 'json' }
  | { kind: 'missing'; key: string; want: string };

const SINGLE = /^\{\{\s*(\w+)\s*\}\}$/;

/** Why a reply-layout side can't be saved (empty = fine), mirroring the server's check: a JSON object that
 *  keeps every required key as its placeholder. Shared by the platform Layout tab and the agent override. */
export const layoutProblems = (text: string, required: Record<string, string>): LayoutProblem[] => {
  let v: unknown;
  try {
    v = JSON.parse(text);
  } catch {
    return [{ kind: 'json' }];
  }
  if (!v || typeof v !== 'object' || Array.isArray(v)) return [{ kind: 'json' }];
  const layout = v as Record<string, unknown>;
  return Object.entries(required)
    .filter(([key, want]) => {
      const got = layout[key];
      return !(typeof got === 'string' && got.match(SINGLE)?.[1] === want.match(SINGLE)?.[1]);
    })
    .map(([key, want]) => ({ kind: 'missing', key, want }));
};

export const layoutProblemText = (p: LayoutProblem, t: TFunction): string =>
  p.kind === 'json'
    ? t('platform.toolErrors.layoutBadJson')
    : t('platform.toolErrors.layoutMissingKey', { key: p.key, value: p.want, interpolation: { escapeValue: false } });
